/**
 * Representation of the Tag Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export class Tag {

    constructor(model, data) {
		// properties
		this.model = model;
		this.id = data.id;
		
		this.labelDE = data.labelDE != null? data.labelDE.trim() : "";
		this.labelEN = data.labelEN != null? data.labelEN.trim() : "";
		this.labelFR = data.labelFR != null? data.labelFR.trim() : "";
		
        this.colorBG = data.colorBG;
        this.colorFG = data.colorFG;
        this.colorBR = data.colorBR;

        // relations
        this.taggedArtist = [];
        this.taggedWork = [];
        this.taggedCollection = [];
        this.taggedExhibition = [];
    }
	
	// Basic Getters
	
	getID() {
		return this.id;
	}
	
	getLabel() {
		if (this.model.getLang() == 'en') {
			return this.labelEN;
		} else if (this.model.getLang() == 'fr') {
			return this.labelFR;
		} else {
			return this.labelDE;
		}		
	}
	
	getColorBG() {
		return this.colorBG;
	}
	
	getColorFG() {
		return this.colorFG;
	}
	
	getColorBR() {
		return this.colorBR;
	}
	
	// Realtions
	
	getTaggedArtist() {
		return this.taggedArtist;
	}
	
	addTaggedArtist(artist) {
		this.taggedArtist.push(artist);
	}
	
	getTaggedWork() {
		return this. taggedWork;
	}
	
	addTaggedWork(work) {
		this.taggedWork.push(work);
	}

	getTaggedCollection() {
		return this.taggedCollection;
	}
	
	addTaggedCollection(collection) {
		this.taggedCollection.push(collection);
	}
	
	getTaggedExhibition() {
		return this.taggedExhibition;
	}
	
	addTaggedExhibition(exhibition) {
		this.taggedExhibition.push(exhibition);
	}
	
}